import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { CommonModule, DatePipe } from '@angular/common';
import { RefreshedDateKey } from '../../enum/refresh-date';
import { StatusResolverService } from '../../services/raintree/Transmission/status-resolver.service';
import { DpTabMenuV3Component } from '../../common-component/dp-tab-menu-v3/dp-tab-menu-v3.component';
@Component({
  selector: 'app-master-search',
  standalone: true,
  templateUrl: './master-search.component.html',
  styleUrl: './master-search.component.scss',
  imports: [RouterModule, CommonModule, DpTabMenuV3Component],
  providers: [DatePipe],
})
export class MasterSearchComponent implements OnInit {
  isMobileView: boolean = false;
  lastRefreshedDate: any
  constructor(private isMobile: CommonUtilService,
    private datePipe: DatePipe,
    private getstatusservice: StatusResolverService
  ) {
  }
  ngOnInit(): void {
    this.fetchStatusDetails()
    let refreshDate: any = JSON.parse(decodeURIComponent(atob(localStorage.getItem('refresh-date')!)))
    if (refreshDate) {
      this.lastRefreshedDate = refreshDate.filter((item: any) => item.configName.includes(RefreshedDateKey.MasterSerach))
      this.lastRefreshedDate = this.datePipe.transform(this.lastRefreshedDate[0].date, 'MMM d, y')
    }
    this.isMobileView = this.isMobile.isMobileDevice();
  }
  fetchStatusDetails() {
    this.getstatusservice.getStatusData().subscribe({
      next: (response: any) => {
        localStorage.setItem('recstatus', btoa(JSON.stringify((response.data))));
      },
      error: (error: any) => {
      },
    });
  }
  showMasterSearch: boolean = true;
}
